import React from "react";
import styles from "../static/css/navbar.module.css";
import { Box, Button } from "@mui/material";
import swal from "sweetalert";
import SecureLS from "secure-ls";
import axios from "axios";
function Navbar() {
  const ls = new SecureLS();
  const path = window.location.pathname.toLowerCase();

  const handleLogout = () => {
    swal("Are you sure you want to log out?", {
      buttons: ["No", "Yes"],
    }).then(async (result) => {
      if (result) {
        const token = ls.get("data")?.token;

        await axios.post("/api/auth/logout", 
         { 
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
        );

        ls.removeAll();
        window.location.replace("/login");
      }
    });
  };

  return path === "/register" || path === "/manageuser" || path === "/edituser" ? (
    <div className={styles.container}>

      <Button
        color="inherit"
        onClick={() => 
          path === "/manageuser" 
            ? (document.location.pathname = "/register") 
            : path === "/edituser"
            ? (document.location.pathname = "/manageuser")
            : (document.location.pathname = "/landing")
        }
        variant="contained"
        sx={{ color: "white", marginX: "15px", backgroundColor:"#272782", '&:hover': {  borderBottom: "2px solid #B2BEB5",boxShadow: 5, backgroundColor:"#1565c0" } }}
      >
        Back
      </Button>

      <Box
        sx={{
          width: "100%",
          height: "40px",
          backgroundColor: "#272782",
          display: "flex",
          // flexDirection: "row",
          marginRight: "150px",
          justifyContent: "flex-end",
          color: "white",
        }}
      >
        {/* find the url and then put classname to each button and then use a common css to the url button  */}
        <Button
          color="inherit"
          onClick={() => (document.location.pathname = "/register")}
          sx={{  marginX: "15px", backgroundColor: path == "/register" ? "#1565c0" : "", '&:hover': { backgroundColor: "#1565c0", borderBottom: "2px solid #1565c0" , boxShadow: 5,} }}
        >
          Register
        </Button>
        <Button
          color="inherit"
          onClick={() => (document.location.pathname = "/manageuser")}
          sx={{ marginX: "15px", backgroundColor: path == "/manageuser" ? "#1565c0" : "", '&:hover': { backgroundColor: "#1565c0", borderBottom: "2px solid #1565c0", boxShadow: 5, } }}
        >
          Manage Users
        </Button>
        <Button color="inherit" onClick={handleLogout}
          sx={{ marginX: "15px",  '&:hover': { backgroundColor: "#1565c0", borderBottom: "2px solid #1565c0", boxShadow: 5, } }}>
          Logout
        </Button>
      </Box>
    </div>
  ) : (
    <div className={styles.container}>
      <Box
        sx={{
          width: "100%",
          height: "40px",
          backgroundColor: "#272782",
          display: "flex",
          // marginRight: "150px",
          // flexDirection: "row",
          justifyContent: "flex-end",
          color: "white",
        }}
      >
        {path === "/landing" &&
          <Button color="inherit" onClick={handleLogout} sx={{ marginX: "15px" }}>
            Logout
          </Button>
        }
      </Box>
    </div>
  )
}

export default Navbar;
